import React from 'react'
// import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
const SimpleQuestion = ({ item, setItem, isGroupNote, ...props }) => {
  // let activeAccordion = 'Intake Form';
  // const { handleSetAnswer } = useNewItemChange(setItem, 'Viewer', activeAccordion);
  return (
    <div className="d-flex gap-10">
      <div className="ar-form-counter flex-center">
        <p className='text text-black'>{props?.itemCount}</p>
      </div>
      <div className="d-flex flex-column gap-6">
        <p className="heading fs-13">
          {/* {item.content} */}
          {item.IsRepeated === 'true' && item.IsGroupEncounter === 'true' && isGroupNote ? item.PatientName + ' - ' + item.content : item.content}
        </p>
        <p className="text">{item.answer || 'N/A'}</p>
      </div>
    </div>
  )
}

export default SimpleQuestion